export const setTrigger = () => ({
    type: 'TRIGGER',
})